module.exports = {
    config: {
        documentType: 'unknown',
    },
    model: {
        trip: null,
        tripAttributes: null,
    },

    methods: {
        prepare: function(storage, isServer){
            const trip = this.model.trip = (storage.request || {}).trip || {}
            const tripData = trip.data || {}
            this.model.tripAttributes = tripData.attributes || {}

            let document
            this.parentComponents('templates_core_documents_document_document', c => document = c)
            if(document){
                this.config.documentType = (document.config || {}).documentType
            }
        },
    }
}